<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-card-title class="primary white--text">
                <h1 class="title">Orion Stereo</h1>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="auth.email"
                    label="Correo electrónico"
                    prepend-icon="fas fa-envelope"
                    :error-messages="errEmail"
                  />
                  <v-text-field
                    v-model="auth.password"
                    label="Contraseña"
                    prepend-icon="fas fa-lock"
                    type="password"
                    :error-messages="errPassword"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="btnDisabled"
                  @click="signin()"
                >Iniciar sesión</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-snackbar v-model="msg.status" :color="msg.color">
      {{msg.text}}
    </v-snackbar>
  </v-app>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      btnDisabled: false,
      auth: {
        email: '',
        password: ''
      },
      msg: {
        status: false,
        text: '',
        color: ''
      }
    }
  },
  computed: {
    errEmail () {
      const errs = []
      if (!this.$v.auth.email.$dirty) return errs
      !this.$v.auth.email.required && errs.push('El correo electrónico no es requerido')
      !this.$v.auth.email.email && errs.push('El correo electrónico no es valido')
      return errs
    },
    errPassword () {
      const errs = []
      if (!this.$v.auth.password.$dirty) return errs
      !this.$v.auth.email.required && errs.push('La contraseña es requerida')
      return errs
    }
  },
  methods: {
    signin () {
      this.$v.auth.$touch()
      if (!this.$v.auth.$invalid) {
        this.btnDisabled = true
        const data = {
          identifier: this.auth.email,
          password: this.auth.password
        }
        this.$http.auth
          .post('/local', data)
          .then(res => res.data)
          .then(res => {
            sessionStorage.setItem('token', res.jwt)
            sessionStorage.setItem('user', res.user)
            this.$router.push({ name: 'main' })
          })
          .catch(() => {
            this.msg = {
              status: true,
              text: 'Ha ocurrido un error al iniciar sesión, revisa tus datos',
              color: 'error'
            }
            this.btnDisabled = false
          })
      }
    }
  },
  validations: {
    auth: {
      email: { email, required },
      password: { required }
    }
  }
}
</script>
